"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodPhotoIdScanStatusFormToJSON = exports.PodPhotoIdScanStatusFormFromJSONTyped = exports.PodPhotoIdScanStatusFormFromJSON = void 0;
const _1 = require("./");
function PodPhotoIdScanStatusFormFromJSON(json) {
    return PodPhotoIdScanStatusFormFromJSONTyped(json, false);
}
exports.PodPhotoIdScanStatusFormFromJSON = PodPhotoIdScanStatusFormFromJSON;
function PodPhotoIdScanStatusFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'documentPurpose': _1.PodPhotoIdScanStatusDocumentPurposeEnumFromJSON(json['documentPurpose']),
        'acuantResponse': _1.AcuantResponseFromJSON(json['acuantResponse']),
    };
}
exports.PodPhotoIdScanStatusFormFromJSONTyped = PodPhotoIdScanStatusFormFromJSONTyped;
function PodPhotoIdScanStatusFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'documentPurpose': _1.PodPhotoIdScanStatusDocumentPurposeEnumToJSON(value.documentPurpose),
        'acuantResponse': _1.AcuantResponseToJSON(value.acuantResponse),
    };
}
exports.PodPhotoIdScanStatusFormToJSON = PodPhotoIdScanStatusFormToJSON;
//# sourceMappingURL=PodPhotoIdScanStatusForm.js.map